import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const Map = () => {
  const [url, setUrl] = useState("https://chotichidiya.s3.ap-southeast-2.amazonaws.com/e3065756-7ac7-4557-94a9-87babd6c7b66.glb");
 const map = useGLTF(url);

  useEffect(() => {
    map.scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [map]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const modelUrl = queryParams.get("link");

  useEffect(() => {
    if (modelUrl) {
      console.log("modelUrl", modelUrl)
      setUrl(modelUrl);
    }
  }, [modelUrl]);

  return (
    <>
      {url && (
        <RigidBody colliders="trimesh" type="fixed">
          <primitive object={map.scene} />
        </RigidBody>
      )}
    </>
  );
};

// Preload the GLTF model outside the component
// if (url) {
//   useGLTF.preload(url);
// }
